import { render, staticRenderFns } from "./LogClienteIndex.vue?vue&type=template&id=e46cd828&"
import script from "./LogClienteIndex.vue?vue&type=script&lang=js&"
export * from "./LogClienteIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
